import { ThemeProvider } from '@emotion/react'
import { useStore } from 'effector-react'
import { sessionModel } from '~/entities/session'

export const withTheme = (component: () => JSX.Element) => () => {
  const theme = useStore(sessionModel.$theme)

  return <ThemeProvider theme={theme || {}}>{component()}</ThemeProvider>
}
